import { __rest } from '../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { useMemo, useCallback } from 'react';
import cns from '../../node_modules/classnames/index.js';
import { getProp } from '../Utils/formHelpers.js';
import useForm from '../Hooks/useForm.js';
import useActivation from '../Hooks/useActivation.js';
import { getRandomId } from '../Utils/baseComponentHelper.js';
import { NOOP } from '../../utils/const.js';

function Checkbox(_a) {
    var { checked, className, defaultChecked, disabled: disabledProp, readOnly: readOnlyProp, indeterminate, name, label, onClick, switch: rSwitch } = _a, others = __rest(_a, ["checked", "className", "defaultChecked", "disabled", "readOnly", "indeterminate", "name", "label", "onClick", "switch"]);
    const { onFormChange, stato, notifica, } = useForm(name, NOOP, true);
    const contesto = (stato && name && getProp(name, stato));
    const { active, disabled, readOnly } = useActivation(disabledProp, readOnlyProp);
    const cbChecked = contesto || checked || defaultChecked || false;
    const uniqueid = useMemo(() => getRandomId(), []);
    const classes = cns('checkbox', {
        'checkbox--switch': rSwitch,
        'checkbox--no-switch': !rSwitch,
        'checkbox--checked': cbChecked,
        'checkbox--enabled': active,
        'checkbox--indeterminate': indeterminate,
        'checkbox--readOnly': readOnly,
        'checkbox--disabled': disabled,
    }, className);
    const data = {};
    if (defaultChecked) {
        data.defaultChecked = defaultChecked;
    }
    else {
        data.checked = contesto || checked || false;
    }
    const labelClassName = cns('checkbox__label', {
        'checkbox__label--disabled': disabled,
        'checkbox__label--readOnly': readOnly,
        'checkbox__label--checked': cbChecked,
    });
    const inputConteinerClassName = cns('checkbox__input-bg', {
        'checkbox__input-bg--switch': rSwitch,
        'checkbox__input-bg--no-switch': !rSwitch,
        'checkbox__input-bg--enabled': active,
    });
    const handleChange = useCallback((e) => {
        if (active)
            notifica(e, name, e.target.checked, onClick, onFormChange, stato);
    }, [active, name, notifica, onClick, onFormChange, stato]);
    const checkboxId = `${name}_${uniqueid}`;
    return (jsxs("label", { className: classes, htmlFor: checkboxId, children: [jsxs("div", { className: inputConteinerClassName, children: [jsx("input", Object.assign({ id: checkboxId, onChange: NOOP }, others, { className: className, disabled: !active, onClick: handleChange, type: "checkbox" }, data)), jsx("span", {})] }), label && typeof label === 'string' && jsx("span", { className: labelClassName, children: label }), typeof label !== 'string' && label] }));
}
Checkbox.defaultProps = {
    checked: false,
    className: '',
    defaultChecked: false,
    disabled: false,
    readOnly: false,
    indeterminate: false,
    name: '',
    onClick: null,
    switch: false,
    label: null,
};

export { Checkbox as default };
